import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container } from '@src/components/Container';
import { Divider } from '@src/components/Divider';
import InvoiceDetails from '@src/containers/InvoiceDetails';
import { setSuccessFlashMessage } from '@src/redux/actions/flashMessages';
import { ContainerType } from '@src/components/Container/enums/containerType.enum';
import './styles.scss';

function CompanyInformation({ setSuccessFlashMessage }) {
  return (
    <Container className="company-information" type={ContainerType.BORDERED}>
      <Divider
        className="company-information__title"
        text={"Specify your company's invoicing details."}
        title="Company information on the invoice"
      />

      <InvoiceDetails
        buttonLabel="Save changes"
        onUpdated={() => setSuccessFlashMessage('Company information successfully updated.')}
      />
    </Container>
  );
}

CompanyInformation.propTypes = {
  setSuccessFlashMessage: PropTypes.func,
};

export default connect(null, { setSuccessFlashMessage })(CompanyInformation);
